<template>
  <section class="mechanics-wrapper" id="mechanics">
    <div class="content-w">
      <div class="content">
        <div class="page-title">
          <img
            src="@/assets/svg/mechanics-title.svg"
            alt="Как принять участие?"
          />

          <h5 class="subtitle">Сроки проведения 1 апреля – 31 августа</h5>
        </div>

        <div class="steps-wrapper">
          <!-- <div class="step-wrapper">
            <img
              src="@/assets/mechanics-1.png"
              class="step-img"
              loading="lazy"
              alt="Покупайте"
            />

            <div class="step-description">
              <p class="step-title">1. Покупайте</p>
              <p class="step-text">пиво Бочкарев</p>
            </div>
          </div> -->

          <div class="step-wrapper">
            <img
              src="@/assets/mechanics-2.png"
              class="step-img"
              loading="lazy"
              alt="Регистрируйте"
            />

            <div class="step-description">
              <p class="step-title">1. Регистрируйте</p>
              <p class="step-text">код под крышкой на сайте</p>
            </div>
          </div>

          <div class="step-wrapper">
            <img
              src="@/assets/mechanics-4.png"
              class="step-img"
              loading="lazy"
              alt="Получайте"
            />

            <div class="step-description">
              <p class="step-title">2. Получайте</p>
              <p class="step-text">гарантированный приз</p>
            </div>
          </div>

          <div class="step-wrapper">
            <img
              src="@/assets/mechanics-3.png"
              class="step-img"
              loading="lazy"
              alt="приз"
            />

            <div class="step-description">
              <p class="step-title no-break">
                3. Обладатели <br />
                гарантированного приза,
              </p>
              <p class="step-text">
                <strong>участвуйте</strong> в розыгрыше еженедельных,
                ежемесячных призов и главном розыгрыше
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Mechanics",

  data: () => ({}),

  methods: {},
};
</script>

<style scoped lang="scss">
.mechanics-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 130px;
  padding-bottom: 127px;

  @media (max-width: 1200px) {
    padding-top: 100px;
    padding-bottom: 130px;
  }

  @media (max-width: 999px) {
    padding-bottom: 60px;
  }

  @media (max-width: 576px) {
    padding-top: 50px;
    padding-bottom: 30px;
  }
}

.page-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;
  position: relative;

  img {
    max-width: 569px;
    width: 569px;
    z-index: 99;
    position: relative;

    @media (max-width: 1200px) {
      max-width: 434px;
      width: 434px;
    }

    @media (max-width: 999px) {
      max-width: 330px;
      width: 330px;
    }

    @media (max-width: 750px) {
      max-width: 270px;
      width: 270px;
    }
  }
}

.subtitle {
  font-family: $regular;
  font-weight: 500;
  font-size: 26px;
  line-height: 100%;
  margin-top: 20px;
  color: white;
  margin-bottom: 56px;

  @media (max-width: 1200px) {
    font-size: 22px;
  }

  @media (max-width: 999px) {
    font-size: 17px;
    margin-bottom: 24px;
  }

  @media (max-width: 750px) {
    font-size: 16px;
    margin-bottom: 40px;
    margin-top: 14px;
  }
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.content-w {
  display: flex;
  justify-content: center;
}

.steps-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;

  @media (max-width: 750px) {
    flex-wrap: wrap;
  }
}

.step-wrapper {
  max-width: 296px;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1200px) {
    max-width: 244px;
  }

  @media (max-width: 999px) {
    max-width: 175px;

    &:last-child {
      max-width: 210px;
    }
  }

  @media (max-width: 750px) {
    max-width: 45%;
    margin-bottom: 35px;

    &:last-child {
      max-width: 45%;
    }
  }
}

.step-img {
  margin-bottom: 24px;
  max-width: 118.5px;

  @media (max-width: 1200px) {
    max-width: 121px;
  }

  @media (max-width: 999px) {
    max-width: 109.5px;
  }
}

.step-description {
  color: white;
  line-height: 100%;
  text-align: center;
}

.step-title {
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 17px;
  line-height: 100%;
  text-align: center;

  @media (max-width: 1200px) {
    font-size: 18px;
    margin-bottom: 13px;
  }

  @media (max-width: 999px) {
    font-size: 17px;
    margin-bottom: 10px;
  }

  @media (max-width: 750px) {
    font-size: 16px;
  }
}

.step-text {
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 0;
  text-align: center;

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 999px) {
    font-size: 14px;
  }

  @media (max-width: 576px) {
    font-size: 12px;
  }

  strong {
    font-size: 22px;

    @media (max-width: 1200px) {
      font-size: 18px;
    }

    @media (max-width: 999px) {
      font-size: 17px;
    }

    @media (max-width: 750px) {
      font-size: 16px;
    }
  }
}

.no-break {
}
</style>
